export default __webpack_public_path__ + "static/media/chevron-right.130232c3.svg";